import {
  BottomSheet,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Text,
  Title,
  type UseModalState,
} from "@clipboard-health/ui-components";
import { DialogContent, Stack } from "@mui/material";
import { DialogFooter } from "@src/appV2/redesign/components/DialogFooter";
import pluralize from "pluralize";

import { Button } from "../../../components/Button";

interface MissingCoreRequiredDocumentsBottomSheetProps {
  modalState: UseModalState;
  onCancel: () => void;
  missingDocuments: string[];
}

export function MissingCoreRequiredDocumentsBottomSheet(
  props: MissingCoreRequiredDocumentsBottomSheetProps
) {
  const { modalState, onCancel, missingDocuments } = props;
  const pluralizedDocument = pluralize("document", missingDocuments.length);

  return (
    <BottomSheet
      modalState={modalState}
      footer={
        <DialogFooter orientation="vertical">
          <Button fullWidth size="large" variant="outlined" onClick={onCancel}>
            Go Back
          </Button>
        </DialogFooter>
      }
    >
      <DialogContent>
        <Stack spacing={2}>
          <Title semibold variant="h4" component="h4" textAlign="center">
            Missing Required Documents
          </Title>
          <Stack sx={{ paddingY: 4 }}>
            <List dense>
              {missingDocuments.slice(0, 6).map((document) => (
                <ListItem key={document}>
                  <ListItemIcon iconType="document" />
                  <ListItemText primary={document} />
                </ListItem>
              ))}
            </List>
          </Stack>
          <Text paragraph>Please upload the above {pluralizedDocument} to accept this invite.</Text>
        </Stack>
      </DialogContent>
    </BottomSheet>
  );
}
